import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { DialogService } from 'src/app/services/dialog.service';
import { formatError } from 'src/app/utils/errorMessage.formatter';
import { ListParams } from 'src/app/models/list-params/list-params.model';
import { ContentSeriesService } from 'src/app/services/content-series.service';
import { ContentSeriesList } from 'src/app/models/content-series/content-series-list.model';

@Component({
    selector: 'app-content-series-list',
    templateUrl: './content-series-list.component.html',
    styleUrls: ['./content-series-list.component.scss'],
    standalone: false
})
export class ContentSeriesListComponent implements OnInit {
    headers = [
        { label:"Title", key:"title", sortable: true },
        { label:"Type", key:"contentType", sortable: true },
        { label:"Date Created", key:"createdAt", sortable: true },
        { label:"Actions" },
    ];

    currentPage = 1;
    searchTerm = "";
    sorting = false;
    loading = false;
    contentSeries:ContentSeriesList;
    sortingParams:{ key?:string, asc?:boolean };
    
    constructor(
        private router:Router,
        private authService:AuthService,
        private dialogService:DialogService,
        private contentSeriesService:ContentSeriesService
    ) { }

    ngOnInit():void {
        this.loadList();
    }

    loadList(hideLoader?:boolean):void {
        var params:ListParams = { page: this.currentPage };
        if (this.searchTerm) 
            params.text = this.searchTerm;
        
        if (this.sortingParams) {
            params.orderBy = this.sortingParams.key;
            params.sort = this.sortingParams.asc ? "asc" : "desc";
        }

        if (!hideLoader)
            this.loading = true;

        this.contentSeriesService.list(params)
            .subscribe(response => {
                this.sorting = false;
                this.loading = false;
                
                response.contentSeries.forEach(c => {
                    c.createdAt = 
                        new Date(c.createdAt).toLocaleDateString('en-US');
                });
                this.contentSeries = response;
            }, 
            errors => {
                this.sorting = false;
                this.loading = false;
                this.dialogService.showErrorAlert(formatError(errors));
                if (errors.status === 401) {
                    this.authService.clearSession();
                    this.router.navigate(['/login']);
                }
            }
        );
    }

    onPageChange(newPage:number) {
        this.currentPage = newPage;
        this.loadList();
    }

    onSearchChange(term:string) {
        this.searchTerm = term;
        this.currentPage = 1;
        this.loadList();
    }

    onSortChange(params:{ key:string, asc:boolean }) {
        this.sorting = true;
        this.sortingParams = params;
        this.loadList(true);
    }
}
